import React from 'react';
import { Document, StyleSheet, Page, Text, View, Image } from '@react-pdf/renderer';
import packageJSON from '../../package.json';
import config from '../config';

const styles = StyleSheet.create({
  page: {
    flexDirection: 'row',
    padding: 10,
  },
  section: {
    flexGrow: 1,
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: '#0AD2C7',
    borderRadius: 5
  },
  header: {
    fontSize: 20,
    textAlign: 'center',
    color: "#0AD2C7",
    marginTop: 30,
    marginBottom: 10,
  },
  imageContainer: {
    flexDirection: 'row',
    alignItems: "center",
    justifyContent: "center"
  },
  image: {
    width: '50%',
    height: 'auto',
    margin: 5,
    borderWidth: 2,
    borderStyle: 'solid',
    borderColor: '#0AD2C7',
    borderRadius: 5
  },
  name: {
    fontSize: 16,
    textAlign: 'center',
    marginTop: 10,
  },
  date: {
    fontSize: 16,
    textAlign: 'center',
    marginTop: 5,
    marginBottom: 5
  },
  red: {
    color: "#EA0F0D",
    fontSize: 20,
    textAlign: 'center',
    marginTop: 15
  },
  green: {
    color: "#43E00C",    
    fontSize: 20,
    textAlign: 'center',
    marginTop: 15
  },
  text: {
    fontSize: 12,
    textAlign: 'center',
    marginTop: 5,
    padding: 10
  },
  footer: {
    position: 'absolute',
    bottom: 30,
    left: 30,
    right: 30,
    textAlign: 'center',
    fontSize: 12,
    color: 'gray',
  },
  footerLine: {
    flexDirection: 'row',
    justifyContent: "center"
  },
  sup: {
    fontSize: 8,
  },
});

const CardioResultPDF = (props) => {
    const { results, name, date } = props.data;
    return (
        <Document>
          <Page size="A4" style={styles.page}>              
            <View style={styles.section}>
              <Text style={styles.header}>Cardio Result</Text>

              <Text style={styles.name}>{name}</Text>
              <Text style={styles.date}>{date}</Text>

              <View style={styles.imageContainer}>
                  <Image src={results[0]} style={styles.image} />
                  <Image src={results[1]} style={styles.image} />
              </View>
              <View style={styles.imageContainer}>
                  <Image src={results[2]} style={styles.image} />
                  <Image src={results[3]} style={styles.image} />
              </View>
              <View style={styles.imageContainer}>
                  <Image src={results[4]} style={styles.image} />
              </View>              

              <View style={styles.footer}>
                <View style={styles.footerLine}>
                  <Text>{config.footer.title}</Text>
                </View>
                <View style={styles.footerLine}>
                  <Text>{config.footer.description} {packageJSON.version}</Text>
                </View>
              </View>
            </View>
          </Page>
        </Document>
      )
};

export default CardioResultPDF;
